import { useQuery } from 'react-query'
import { notification } from 'antd'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '../../api'
import { ApiParams } from '../../types'
import SuppliersViewApi from './api'

interface UseSuppliersViewProps extends ApiParams {}

const useSuppliersView = ({ filters }: UseSuppliersViewProps) => {
  const { t } = useTranslation()
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.SUPPLIERS_ADMIN, filters],
    () => SuppliersViewApi.getSuppliersByFilters({ filters }),
    {
      staleTime: Infinity,
      onError: () => {
        notification.error({
          message: t('suppliers_error'),
        })
      },
    },
  )

  return {
    suppliers: data,
    isLoading,
  }
}

export default useSuppliersView
